import { UploadDocumentos } from 'src/compartilhados'
import {
  ResumoDocumentosAlunoCertificacao,
  ResumoDocumentosProfessorCertificacao,
  ResumoDocumentosCursoCertificacao,
  ResumoDocumentosParceiroCertificacao,
  ResumoDocumentosTurmaCertificacao,
  SituacaoUpload
} from 'src/tipos'

export function MapearDocumentosAlunoCertificacao(
  resumo: ResumoDocumentosAlunoCertificacao[]
): UploadDocumentos[] {
  return resumo.map((doc, index) => ({
    id: doc.documentoId,
    documentoId: doc.documentoId,
    nome: doc.nomeArquivo,
    tipo: doc.tipo,
    status: doc.situacaoUpload,
    obrigatorio: true,
    ordemExibicao: index,
    analisado: false,
    motivoDaRejeicao: doc.motivoRejeicao ?? ''
  }))
}

export function MapearDocumentosProfessorCertificacao(
  resumo: ResumoDocumentosProfessorCertificacao[]
): UploadDocumentos[] {
  return resumo.map((doc, index) => ({
    id: doc.documentoId,
    documentoId: doc.documentoId,
    nome: doc.nomeArquivo,
    tipo: doc.tipo,
    status: doc.situacaoUpload,
    obrigatorio: true,
    ordemExibicao: index,
    analisado: false,
    motivoDaRejeicao: doc.motivoRejeicao ?? ''
  }))
}

export function MapearDocumentosCursoCertificacao(
  resumo: ResumoDocumentosCursoCertificacao[]
): UploadDocumentos[] {
  return resumo.map((doc, index) => ({
    id: doc.documentoId,
    documentoId: doc.documentoId,
    nome: doc.nomeArquivo,
    tipo: doc.tipo,
    status: doc.situacaoUpload,
    obrigatorio: true,
    ordemExibicao: index,
    analisado: false,
    motivoDaRejeicao: doc.motivoRejeicao ?? ''
  }))
}

export function MapearDocumentosTurmaCertificacao(
  resumo: ResumoDocumentosTurmaCertificacao[]
): UploadDocumentos[] {
  return resumo.map((doc, index) => ({
    id: doc.documentoId,
    documentoId: doc.documentoId,
    nome: doc.nomeArquivo,
    tipo: doc.tipo,
    status: doc.situacaoUpload,
    obrigatorio: true,
    ordemExibicao: index,
    analisado: false,
    motivoDaRejeicao: doc.motivoRejeicao ?? ''
  }))
}

export function MapearDocumentosParceiroCertificacao(
  resumo: ResumoDocumentosParceiroCertificacao[]
): UploadDocumentos[] {
  return resumo.map((doc, index) => ({
    id: doc.documentoId,
    documentoId: doc.documentoId,
    nome: doc.nomeArquivo,
    tipo: doc.tipo,
    status: doc.situacaoUpload,
    obrigatorio: true,
    ordemExibicao: index,
    analisado: false,
    motivoDaRejeicao: doc.motivoRejeicao ?? ''
  }))
}
